/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcTenancyBienDto } from './ParcTenancyBienDto';
import {
    ParcTenancyBienDtoFromJSON,
    ParcTenancyBienDtoFromJSONTyped,
    ParcTenancyBienDtoToJSON,
    ParcTenancyBienDtoToJSONTyped,
} from './ParcTenancyBienDto';

/**
 * 
 * @export
 * @interface ParcTenancyFileResponse
 */
export interface ParcTenancyFileResponse {
    /**
     * 
     * @type {number}
     * @memberof ParcTenancyFileResponse
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof ParcTenancyFileResponse
     */
    validCount: number;
    /**
     * Biens sans locataire ou sans aucun locataire valide
     * @type {number}
     * @memberof ParcTenancyFileResponse
     */
    blockingCount: number;
    /**
     * 
     * @type {Array<ParcTenancyBienDto>}
     * @memberof ParcTenancyFileResponse
     */
    items: Array<ParcTenancyBienDto>;
}

/**
 * Check if a given object implements the ParcTenancyFileResponse interface.
 */
export function instanceOfParcTenancyFileResponse(value: object): value is ParcTenancyFileResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('validCount' in value) || value['validCount'] === undefined) return false;
    if (!('blockingCount' in value) || value['blockingCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ParcTenancyFileResponseFromJSON(json: any): ParcTenancyFileResponse {
    return ParcTenancyFileResponseFromJSONTyped(json, false);
}

export function ParcTenancyFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcTenancyFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'validCount': json['validCount'],
        'blockingCount': json['blockingCount'],
        'items': ((json['items'] as Array<any>).map(ParcTenancyBienDtoFromJSON)),
    };
}

export function ParcTenancyFileResponseToJSON(json: any): ParcTenancyFileResponse {
    return ParcTenancyFileResponseToJSONTyped(json, false);
}

export function ParcTenancyFileResponseToJSONTyped(value?: ParcTenancyFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'validCount': value['validCount'],
        'blockingCount': value['blockingCount'],
        'items': ((value['items'] as Array<any>).map(ParcTenancyBienDtoToJSON)),
    };
}

